import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
    DEFAULT_NOTE_HEIGHT,
    DEFAULT_NOTE_WIDTH, EVENT_BOARD_CHANGED,
    EVENT_FAVIRIATE_CHANGE,
    EVENT_REFRESH_HIGHLIGHT_LIST,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_SHOW_DESKTOP_PRO_VIP,
    EVENT_SWITCH_HOME_LIST_MENU,
    FROM_ADD,
    FROM_HOME_HIGHLIGHT, FROM_HOME_LIBRARY,
    FROM_LIBRARY,
    getNoteElementBackgroundColor,
    getNoteElementStrokeColor,
    HEADER_HEIGHT,
    KEY_CARD_ORDER_BY,
    KEY_FILE_DIR,
    KEY_FILTER_SELECT_PROJECT_HIGHLIGHT,
    KEY_FILTER_SELECT_TAG,
    KEY_FILTER_SELECT_TAG_HIGHLIGHT,
    KEY_HIGHLIGHT_ORDER_BY,
    KEY_HIGHLIGHT_SELECTED_TYPES,
    KEY_HIGHLIGHT_SORT_TYPE,
    KEY_LIBRARY_SELECTED_TYPES,
    LEFT_MENU_WIDTH,
    MENU_SEPARATOR,
    PAGE_TITLE_MARGIN_TOP, SEARCH_WIDTH, WIDTH_3, WIDTH_4, WIDTH_5
} from "@/Const";
import {Checkbox, ConfigProvider, Dropdown, Input, message, Select, Spin, Tooltip} from "antd";
import {IconDropdownSelected, IconHomeSearch, IconIndicatorBlue} from "@/Icon";
import {
    createCopyLink, createEmptyProject,
    generateUUID2, getAudioFilterExt, getBase64ImageSize,
    getFileNameExt,
    getImagePathWithTheme, getVideoScale, hasBeyondFreeLimit,
    imgPathPerfix, isArray,
    isDarkMode, isFileElement, isPdf, isShortcuts, isString,
    isStringNullOrEmpty, isSupportVideoAnnoUrl, isVideo, isYoutubeUrl
} from "@/utils";
import {t} from "i18next";
import {isZh} from "@/language";
import "./PageHighlight.css"
import {CheckOutlined} from "@ant-design/icons";
import CardItem from "@/views/Library/CardItem";
import {getCardById, getCardDoc, renameCard, renameCardById, updateCard} from "@model/card";
import {deleteAllCardFromRefProject, getNoteDoc, getNoteList, updateNote, updateNoteDoc} from "@model/note";
import {editDoc} from "@model/doc";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import Global from "@/global";
import {openEditor} from "@/state";
import style from "@/views/Library/PageLibrary.module.less";
import {dbGetHighlight, highlightList, updateHighlight} from "@model/highlight";
import {ROUNDNESS} from "../../../@excalidraw/packages/excalidraw/constants";
import DialogChooseProject from "@/views/Dialog/DialogChooseProject";
import clipboard from "clipboardy";
import HomeNavigator from "@/views/Home/HomeNavigator";
import {getDrawPath, getSearchWidth} from "@/Utility";
import {getTagList} from "@model/tag";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";
import global from "@/global";
import {exportCurrentElementVideoNotes, getCurrentElementVideoNotes, onImportHighlights} from "@/VideoHighlightUtils";
import {saveElementVideoNotesAsJSON} from "../../../@excalidraw/packages/excalidraw/data/json";
import {Grid} from 'react-virtualized';
import {measureTitleHeight} from "@/views/Utils/CardUtils";

let mSearchKey:any;

let mSelectProjectId:any='all';
let mSortTypeDesc = "Last viewed";
let COLUMN_COUNT = 5;

const FILTER_PROJECT_ID_ALL = "all";
const FILTER_PROJECT_ID_ALL_IN_PROJECT = "allInProject";
const FILTER_PROJECT_ID_NOT_IN_PROJECT_ALL = "notInProject";
const FILTER_PROJECT_CURRENT_PROJECT = "currentProject";
const FILTER_PROJECT_CURRENT_BOARD = "currentBoard";
const CHECK_ALL = "checkAll";
let mArrayProjects:any = [];
let mArraySelectedTypes:any=[];
let mProjectInfo:any;

let mArrayTags:any = [];
let mSelectTag:any;

const PageHighlight = forwardRef((props:{from?:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onSearchEvent:onSearchEvent,
        onSliderEvent:onSliderEvent,
    }))
    const ARRAY_LIBRARY_TYPES = [
        {
            value:'pdf',
            label:t("PDF"),
            buttonLabel:t("New PDF"),
            ext:'.pdf'
        },
        {
            value:'youtube',
            label:t("Online video"),
            buttonLabel:t("New youtube"),
        },
        {
            value:'video',
            label:t("Local video"),
            buttonLabel:t("New video"),
            ext:'.mp4,.mov'
        },
        {
            value:'audio',
            label:t("Local audio"),
            buttonLabel:t("New audio"),
            ext:'.mp3'
        },
        {
            value:MENU_SEPARATOR,
            label:t(""),
            buttonLabel:'',
            ext:'*'
        },
        {
            value:CHECK_ALL,
            label:t("Select all"),
            buttonLabel:'',
            ext:'*'
        }
    ]

    const [sortMenu, setSortMenu] = useState([
        {
            key: "sort by",
            type: 'group',
            label: t('Sort by'),
            children: [
                {
                    key: 'sort by name',
                    label: t("alphabetical"),
                    icon: <CheckOutlined style={{color:'white',fontSize:'0px'}}/>
                },
                {
                    key: 'sort by createDate',
                    label: t('Date created')
                },
                {
                    key: 'sort by updateDate',
                    label: t('Last viewed')
                }
            ]
        },
        {
            key: "order",
            type: 'group',
            label: t('Order'),
            children: [
                {
                    key: 'date asc',
                    label: t('Oldest first')
                },
                {
                    key: 'date desc',
                    label: t('Newest first')
                }
            ]
        }
    ])

    const [isShowSearch,setIsShowSearch] = useState(false);
    const [isOpenProjectType,setIsOpenProjectType] = useState(false);
    const [isOpenProjectSelect,setIsOpenProjectSelect] = useState(false);
    const [isClearFilterVisible,setIsClearFilterVisible] = useState(false);
    const [isShowChecked,setIsShowChecked] = useState(false);
    const [isEmptyData,setIsEmptyData] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const [sortMenuOpen,setSortMenuOpen] = useState(false);
    const [arrayLibraryTypes,setArrayLibraryTypes] = useState(ARRAY_LIBRARY_TYPES);
    const [arrayProjects,setArrayProjects] = useState([]);
    const [arrayCardList,setArrayCardList] = useState([]);
    const [selectProjectValue,setSelectProjectValue] = useState(mSelectProjectId);
    const [cardItemSize,setCardItemSize] = useState({width:0,height:0});
    const [gridColumns,setGridColumns] = useState('repeat(5,auto)');
    const [sortTypeDesc,setSortTypeDesc] = useState(mSortTypeDesc);
    const [tipsInfo,setTipsInfo] = useState('');
    const [searchKey,setSearchKey] = useState('');

    const [isOpenTagSelect,setIsOpenTagSelect] = useState(false);
    const [arrayTags,setArrayTags] = useState([]);
    const [selectTagValue,setSelectTagValue] = useState(t("Tags"));

    const [,updateState] = useState();
    const forceUpdate = React.useCallback(()=>updateState({}),[]);

    const dialogChooseProjectRef = useRef(null);
    const mArrayPdfDatas = useRef(null);
    const divPageLibraryContainerRef = useRef(null);
    const gridRef = useRef(null);
    const divGridContainerRef = useRef(null);
    const mColumnCount = useRef(4);
    const mPageNum = useRef<any>(0);
    const mIsLoadingMore = useRef(false);

    function onKeydown(e){
        // debugLog('keydown',e);
        if (e.target?.type != 'text' &&
            e.target?.type != 'textarea' &&
            e.target?.className.indexOf('ql-editor') != 0 &&
            e.target.dataset?.isedit != 'true' &&
            e.target?.className.indexOf('tiptap') != 0) {
            if (isShortcuts(e,'newCard')){
                e.stopPropagation();
                e.preventDefault();
                e.stopImmediatePropagation();
                window.showDialogCard({id:crypto.randomUUID(),tags:[]});
            }
        }
    }

    useEffect(()=>{
        recvMessage(EVENT_REFRESH_HIGHLIGHT_LIST,(msg,data)=>{
            mPageNum.current = 0;
            updateList();
        })

        window.addEventListener('resize',onWindowResize);
        document.body.addEventListener('keydown',onKeydown);
        return ()=>{
            window.removeEventListener('resize',onWindowResize);
            document.body.removeEventListener('keydown',onKeydown);
            unSubscribe(EVENT_REFRESH_HIGHLIGHT_LIST);
        }
    })

    useEffect(()=>{

        recvMessage(EVENT_BOARD_CHANGED,(msg,data)=>{
            if (mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD){
                updateList();
            }
        })

        //调整大小
        onWindowResize(null);

        mPageNum.current = 0;

        //保存的类型项目
        const szSelectTypes = localStorage.getItem(KEY_HIGHLIGHT_SELECTED_TYPES);
        if (szSelectTypes){
            const arraySavedSelectTypes = JSON.parse(szSelectTypes);
            mArraySelectedTypes.length = 0;

            for (let i=0;i<ARRAY_LIBRARY_TYPES.length;i++){
                const array = arraySavedSelectTypes.filter(p=>p.value == ARRAY_LIBRARY_TYPES[i].value);
                if (array && array.length > 0){
                    mArraySelectedTypes.push({
                        ...ARRAY_LIBRARY_TYPES[i],
                        isChecked:array[0].isChecked
                    })
                }
            }
            setArrayLibraryTypes(mArraySelectedTypes);
        }else{
            var arrays = [...ARRAY_LIBRARY_TYPES];
            arrays[0].isChecked = true;
            arrays[1].isChecked = true;
            arrays[2].isChecked = true;
            arrays[4].isChecked = true;
            setArrayLibraryTypes(arrays);
            mArraySelectedTypes = arrays;
        }

        const szTags = localStorage.getItem(KEY_FILTER_SELECT_TAG_HIGHLIGHT);
        if (szTags){
            setSelectTagValue(szTags);
            mSelectTag = szTags;
        }else{
            setSelectTagValue(t('Tags'));
            // mSelectTag = t('Tags');
        }

        mSelectProjectId = localStorage.getItem(KEY_FILTER_SELECT_PROJECT_HIGHLIGHT);
        if (!mSelectProjectId){
            mSelectProjectId = FILTER_PROJECT_ID_ALL;
        }

        if (props.from == FROM_LIBRARY){

        }else{
            //非右侧栏，
            if (mSelectProjectId == FILTER_PROJECT_CURRENT_PROJECT || mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD){
                mSelectProjectId = FILTER_PROJECT_ID_ALL;
            }
            mSearchKey = '';
        }


        setIsClearFilterVisible((mSelectTag && mSelectTag != t('Tags')) || !isAllProject());
        setSelectProjectValue(mSelectProjectId);


        //查询所有project
        getNoteList().then((res:any)=>{
            mArrayProjects.length = 0;

            mArrayProjects.push({
                value:'all',
                label:t("Projects")
            });
            mArrayProjects.push({
                value:'all-0',//allInProject
                label:t("All projects")
            });
            mArrayProjects.push({
                value:'notInProject',
                label:t("Not in any project")
            })

            if (props.from == FROM_LIBRARY){
                //库里面，增加2个
                mArrayProjects.push({
                    value:FILTER_PROJECT_CURRENT_PROJECT,
                    label:t("Current project")
                })
                mArrayProjects.push({
                    value:FILTER_PROJECT_CURRENT_BOARD,
                    label:t("Current board")
                })
            }

            mArrayProjects.push({
                id:MENU_SEPARATOR,
                label:'',
                value:'spe0'
            })
            res.forEach(p=>{
                mArrayProjects.push({
                    value:p.id,
                    label:p.name
                })
            })
            setArrayProjects(mArrayProjects);
        })

        updateSortStates();
        updateList();
        //查询所有tag..
        updateTagList();

        window.refreshList['updateTheme_pageHighlight'] = forceUpdate;

        return ()=>{
            unSubscribe(EVENT_BOARD_CHANGED);
            delete  window.refreshList['updateTheme_pageHighlight'];
        }
    },[])

    useEffect(() => {
        setTimeout(()=>{
            gridRef.current?.recomputeGridSize();
        },10)
    }, [arrayCardList]);

    /**
     * 搜索
     */
    const onSearchEvent = (szSearchKey:any)=>{
        mSearchKey = szSearchKey;
        setSearchKey(mSearchKey);
        updateList();
    }

    /**
     * 窗口大小调整
     * @param event
     */
    function onWindowResize(event:any){
        const divContainer = document.getElementById('divPageHighlightContainer');
        if (divContainer){
            onSliderEvent(divContainer.clientWidth);//左右边距
        }
    }

    /**
     * 拖动大小
     * @param nWidth
     */
    const onSliderEvent = (nWidth:number)=>{

        if (nWidth > WIDTH_5){
            mColumnCount.current = 5;
            setGridColumns('repeat(5,auto)');
        }else if (nWidth > WIDTH_4){
            mColumnCount.current = 4;
            setGridColumns('repeat(4,auto)');
        }else if (nWidth > WIDTH_3){
            mColumnCount.current = 3;
            setGridColumns('repeat(3,auto)');
        }
        else{
            mColumnCount.current = 2;
            setGridColumns('repeat(2,auto)');
        }

        let fItemWidth = 200;
        const nMargin = (mColumnCount.current - 1)*12;
        fItemWidth = (nWidth - 12*2 - mColumnCount.current*16)/mColumnCount.current;//32为左右2边的边距
        setCardItemSize({
            width:fItemWidth,
            height:fItemWidth*0.67
        })

        setTimeout(()=>{
            gridRef.current?.recomputeGridSize();
        },10)
    }

    /**
     * 重新排序
     * @param arrayCards
     */
    const reSortData = async (arrayCards:any)=>{
        if (!isStringNullOrEmpty(mSelectProjectId)){
            arrayCards = await filterByProjectId(arrayCards);
        }

        let szSortType = localStorage.getItem(KEY_HIGHLIGHT_SORT_TYPE);
        let szOrderBy = localStorage.getItem(KEY_HIGHLIGHT_ORDER_BY);

        if(!szSortType){
            szSortType = "sort by updateDate";
        }
        if(!szOrderBy){
            szOrderBy = "date desc"
        }

        if("sort by name" === szSortType){
            if("a-z" === szOrderBy){
                arrayCards.sort((a,b)=>{
                    if(a.name == undefined || b.name == undefined)return 0;
                    return a.name.localeCompare(b.name);
                })
            }else if("z-a" == szOrderBy){
                arrayCards.sort((a,b)=>{
                    if(a.name == undefined || b.name == undefined)return 0;
                    return b.name.localeCompare(a.name);
                })
            }
        }else if("sort by createDate" == szSortType){
            if("date asc" == szOrderBy){
                arrayCards.sort((a,b)=>{
                    return a.createTime - b.createTime;
                })
            }else if("date desc" == szOrderBy){
                arrayCards.sort((a,b)=>{
                    return b.createTime - a.createTime;
                })
            }
        } else if("sort by updateDate" == szSortType){
            if("date asc" == szOrderBy){
                arrayCards.sort((a,b)=>{
                    return a.updateTime - b.updateTime;
                })
            }else if("date desc" == szOrderBy){
                arrayCards.sort((a,b)=>{
                    return b.updateTime - a.updateTime;
                })
            }
        }
        return arrayCards;
    }

    /**
     * 更新列表
     */
    const updateList = async ()=>{
        const res = await ipcInvoke('list-pdf-annotation');
        mArrayPdfDatas.current = res;
        var arrayNewCards:any = [];
        const arrayTypes:any = [];
        for (let i=0;i<mArraySelectedTypes.length;i++){
            if (mArraySelectedTypes[i].isChecked){
                arrayTypes.push(mArraySelectedTypes[i].value);
            }
        }
        if (arrayTypes.includes('pdf')){
            for (let i=0;i<res.length;i++){
                const pdfData = (res[i]);
                let card:any = await getCardById(pdfData.id);
                try {
                    if (card && card.type == 'pdf' && card.isDeleted == 0){
                        const arrayAnnos = JSON.parse(pdfData.data);
                        card.highlightsCount = arrayAnnos.length;
                        let isContainer = true;
                        if (mSearchKey){
                            mSearchKey = mSearchKey.toLowerCase();
                            isContainer = arrayAnnos.some(p=>p.text?.toLowerCase()?.indexOf(mSearchKey) != -1) || card.name?.toLowerCase()?.includes(mSearchKey);
                        }
                        if (isContainer){
                            arrayNewCards.push(card);
                        }
                    }
                }catch (ex){
                    console.log(ex);
                }
            }
        }
        const arrayDb:any = await highlightList(mSearchKey,arrayTypes);
        //删除的不显示....
        for (let i=0;i<arrayDb.length;i++){
            const card:any = await getCardById(arrayDb[i].id);
            arrayDb[i].highlightsCount = arrayDb[i].data.length;
            if ((card && card.isDeleted != 1)){
                if (card.name){
                    arrayDb[i].name = card.name;
                }

                arrayNewCards.push(arrayDb[i])
            }else if (arrayDb[i].type == 'youtube'){
                arrayNewCards.push(arrayDb[i])
            }
        }

        //过滤一下标签..
        if (mSelectTag){
            arrayNewCards = arrayNewCards.filter(p=>p.tags?.includes(mSelectTag))
        }

        //这里排序....
        arrayNewCards = await reSortData(arrayNewCards);

        setArrayCardList(arrayNewCards);

        setIsEmptyData(arrayNewCards.length == 0);

        if (window.closeRightSliderSearch){
            window.closeRightSliderSearch();
        }
        if (window.closeDrawSearching){
            window.closeDrawSearching();
        }
    }

    /**
     * 选中的类型数量
     */
    const getSelectedTypes = ()=>{
        return mArraySelectedTypes.filter(p=>p.isChecked);
    }

    /**
     * 通过项目过滤
     */
    const filterByProjectId = async (arrayCards:any)=>{
        let arrayNewCards:any = [];
        const arraySelectTypes = getSelectedTypes();
        const isCard = arraySelectTypes.some(p=>p.value == 'card');

        let szSelectProjectId = mSelectProjectId;
        if (szSelectProjectId == FILTER_PROJECT_CURRENT_PROJECT || szSelectProjectId == FILTER_PROJECT_CURRENT_BOARD){
            szSelectProjectId = PROJECT_ID;//当前项目的ID
        }

        if (isAllProject()){
            //列表里面，有在项目的...
            return arrayCards;
        }else if (szSelectProjectId == FILTER_PROJECT_ID_ALL_IN_PROJECT || szSelectProjectId == FILTER_PROJECT_ID_NOT_IN_PROJECT_ALL){
            var arrayNewCard = [];
            const arrayNoteLists:any = await getNoteList();

            for (let i=0;i<arrayNoteLists.length;i++){
                const item = arrayNoteLists[i];
                const jsonObj = await getNoteDoc(item.id);
                const jsonDoc = JSON.parse(jsonObj.doc);
                if (isCard){
                    //仅note...
                    for (let j=0;j<jsonDoc.notes.length;j++){
                        const note = jsonDoc.notes[j];
                        const card:any = await getCardById(note.key,false);
                        //未添加过的，添加进来
                        if (card && !arrayNewCards.some(p=>p.id == card?.id)){
                            arrayNewCards.push(card);
                        }
                    }
                }

                for (let i=0;i<jsonDoc.canvas.length;i++) {
                    const canvas = jsonDoc.canvas[i];
                    for (let j = 0; j < canvas.drawJson.elements.length; j++) {
                        const element = canvas.drawJson.elements[j];
                        if (isFileElement(element)){
                            const card:any = await getCardById(element.customData?.generationData?.id,false);
                            //未添加过的，添加进来
                            if (card && arraySelectTypes.some(p=>p.value == card.type) && !arrayNewCards.some(p=>p.id == card?.id)){
                                arrayNewCards.push(card);
                            }
                        }
                    }
                }
            }
            if (szSelectProjectId == 'notInProject'){
                //取差集...
                let arrayNew:any = [];
                for (let i=0;i<arrayCards.length;i++){
                    if (!arrayNewCards.some(p=>p.id == arrayCards[i].id)){
                        arrayNew.push(arrayCards[i]);
                    }
                }
                arrayNewCards = arrayNew;
            }
            return arrayNewCards;

        }

        const jsonObj = await getNoteDoc(szSelectProjectId);
        const jsonDoc = JSON.parse(jsonObj.doc);
        if (isCard){
            //仅note...
            for (let i=0;i<jsonDoc.notes.length;i++){
                const arrayItems = arrayCards.filter(p=>p.id == jsonDoc.notes[i].key);
                if (arrayItems.length > 0){
                    if (!arrayNewCards.some(p=>p.id == arrayItems[0].id)) {
                        arrayNewCards.push(arrayItems[0]);
                    }
                }
            }
        }else{

        }

        for (let i=0;i<jsonDoc.canvas.length;i++){
            const canvas = jsonDoc.canvas[i];
            if (mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD){
                if (canvas.key != global.g_currentBoardId)continue;
            }

            for (let j=0;j<canvas.drawJson.elements.length;j++){
                const element = canvas.drawJson.elements[j];
                const arrayItems = arrayCards.filter(p=>p.id == element.id || p.id == element.customData?.generationData?.id);
                if (arrayItems.length > 0){
                    if (!arrayNewCards.some(p=>p.id == arrayItems[0].id)){
                        arrayNewCards.push(arrayItems[0]);
                    }

                    // if (mSelectType.value == 'pdf' && isPdfFileElement(element)){
                    //     arrayNewCards.push(arrayItems[0]);
                    // }else if (mSelectType.value == 'audio' && isAudioFileElement(element)){
                    //     arrayNewCards.push(arrayItems[0]);
                    // }else if (mSelectType.value == 'video' && isFileVideoElement(element)){
                    //     arrayNewCards.push(arrayItems[0]);
                    // }else if (mSelectType.value == 'file' && isOtherFileElement(element)){
                    //     arrayNewCards.push(arrayItems[0]);
                    // }
                }
            }
        }

        return arrayNewCards;
    }

    /**
     * 更新排序的描述
     * @param szSortType
     */
    const updateSortTypeDesc = (szSortType)=>{
        for(var i=0;i<sortMenu[0].children.length;i++){
            var item = sortMenu[0].children[i];
            if (item.key == szSortType){
                setSortTypeDesc(item.label);
                mSortTypeDesc = item.label;
            }
        }
    }

    /**排序*/
    const onSortMenuClick = (e) => {
        if ("sort by name" == e.key || "sort by createDate" == e.key || "sort by updateDate" == e.key) {
            // updateSortOrderByMenu(e.key);
            setSortMenuOpen(true);
            localStorage.setItem(KEY_HIGHLIGHT_SORT_TYPE,e.key);
            //默认选中Order by 的第一个.
            if("sort by name" == e.key){
                onSortMenuClick({key:'a-z'})
            }else{
                onSortMenuClick({key:'date desc'})
            }
        } else {
            setSortMenuOpen(false);
            localStorage.setItem(KEY_HIGHLIGHT_ORDER_BY,e.key);
            //更新列表
            mPageNum.current = 0;
            updateList();
        }
        updateSortStates();
    }

    /*排序状态选中*/
    const updateSortStates = async ()=>{
        let szSortType = localStorage.getItem(KEY_HIGHLIGHT_SORT_TYPE);
        let szOrderBy = localStorage.getItem(KEY_HIGHLIGHT_ORDER_BY);

        if(!szSortType){
            szSortType = "sort by updateDate";
        }
        if(!szOrderBy){
            szOrderBy = "date desc"
        }

        //更新排序描述文字
        updateSortTypeDesc(szSortType);

        var arraySortMenus = [...sortMenu];
        if ("sort by name" == szSortType) {
            var sortMenuA = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'a-z',
                        label: 'A-Z',
                        icon: <CheckOutlined />,
                    },
                    {
                        key: 'z-a',
                        label: 'Z-A'
                    }
                ]
            }
            arraySortMenus[1] = sortMenuA;
        } else {
            var sortMenuDate = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'date asc',
                        label: t('Oldest first')
                    },
                    {
                        key: 'date desc',
                        label: t('Newest first')
                    }
                ]
            }
            arraySortMenus[1] = sortMenuDate;
        }

        var item0 = arraySortMenus[0];
        for(var i=0;i<item0.children.length;i++){
            var child = item0.children[i];

            if(child.key == szSortType){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        var item1 = arraySortMenus[1];
        for(var i=0;i<item1.children.length;i++){
            var child = item1.children[i];

            if(child.key == szOrderBy){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        setSortMenu(arraySortMenus);
    }

    /*排序菜单显示状态更改*/
    const handleSortOpenChange = (nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
            setSortMenuOpen(nextOpen);
        }
    }

    /**
     * 更新标签列表
     */
    const updateTagList = ()=>{
        getTagList().then(res=>{
            mArrayTags.length = 0;

            res.forEach(p=>{
                mArrayTags.push({
                    value:p.id,
                    label:p.name
                })
            })
            setArrayTags(mArrayTags);
        })
    }

    /**
     * 类型条目点击....
     * @param p
     * @param isChecked
     */
    const onCheckedItemClicked = (p,isChecked)=>{
        var arrayNew = [...arrayLibraryTypes];

        if (p.value == CHECK_ALL) {
            arrayNew.forEach(pp => pp.isChecked = isChecked);
        }else {
            p.isChecked = isChecked;

            //判断all
            const itemAll = arrayNew[arrayNew.length -1];
            itemAll.isChecked = arrayNew.filter(pp=>pp.isChecked && pp.value != MENU_SEPARATOR && pp.value != CHECK_ALL).length == (arrayNew.length - 2);
        }

        mArraySelectedTypes = arrayNew;
        setArrayLibraryTypes(arrayNew);
        localStorage.setItem(KEY_HIGHLIGHT_SELECTED_TYPES,JSON.stringify(arrayNew));

        //刷新列表
        mPageNum.current = 0;
        updateList()
    }

    /**
     * 是否是全部项目
     */
    const isAllProject = ()=>{
        return mSelectProjectId == FILTER_PROJECT_ID_ALL || mSelectProjectId == 'all-0'
    }

    /**
     * 更改source
     */
    const changeSourceEvent = (item:any)=>{
        //选择的
        const arrayChecked:any = [];
        let bPdf = arrayChecked.some(p=>(p.type == 'pdf' || p.type == 'pdfAnno'));
        let bVideo = arrayChecked.some(p=>(p.type == 'video' || p.type == 'videoAnno'));
        if (bPdf && bVideo){
            message.error(t("PleaseChooseOnlyType"));
            return;
        }
        if (item){
            arrayChecked.push(item);
        }
        let filter = [{ name: 'Videos', extensions: ['mp4', 'mov', '3gp','mpeg'] }];
        if (item.type == 'pdfAnno' || item.type == 'pdf'){
            filter = [{ name: 'pdf', extensions: ['pdf'] }];
        }else if (item.type == 'audioAnno' || item.type == 'audio'){
            filter = [{ name: 'audio', extensions: getAudioFilterExt() }];
        }
        ipcInvoke('getFilePath',{filter}).then(async (res)=>{
            if (res){
                for (let i=0;i<arrayChecked.length;i++){
                    let item = arrayChecked[i];
                    if (item.type == 'video' || item.type == 'pdf' || item.type == 'audio' || item.type == 'videoAnno' || item.type == 'pdfAnno' || item.type == 'audioAnno'){
                        if (item.type == 'pdfAnno' || item.type == 'videoAnno' || item.type == 'audioAnno'){
                            item = await getCardById(item.libraryId);
                        }
                        if (item.type == 'pdf' || item.type == 'video' || item.type == 'audio'){
                            item.isAbsolutePath = true;
                            item.fileName = res;
                            await updateCard(item);
                        }
                    }
                }
            }
        })
    }

    /**
     * 渲染标题行
     */
    const renderTitleRow = ()=>{
        if (isShowChecked){
            return <>
                {/*<span className='header-title font-family-semi-bold' style={{marginBottom: '1px'}}>{showCheckedTitle}</span>*/}
                {/*<div style={{height:'16px',width:'1px',background:'var(--line-color)',margin:'0 16px'}}></div>*/}
                <span className={'cursor-pointer button-border-gray-style flex-center ml-16'} style={{height:'32px',width:'106px',marginLeft:'22px'}} onClick={()=>{
                    onCancelCheck();
                }}>{t("Cancel")}</span>

                <div style={{flexGrow: '1'}}></div>

                <div className={'flex-row-vertical-center'}>
                    {/*add to project*/}
                    <div style={{minWidth: '130px',height:'32px',marginLeft:'16px',}} onClick={()=>{
                        addToProjectEvent();
                    }}
                         className={'button-border-gray-style flex-center'}>{t("Add to project")}</div>


                    {/*remove*/}
                    <div style={{minWidth: '80px',marginLeft:'16px',height:'32px'}} onClick={()=>{
                        deleteSelectedEvent();
                    }}
                         className={'button-border-danger-style flex-center'}>{t("Delete")}</div>
                </div>
            </>
        } else {
            return <>
                {/*标题名称*/}
                <span className='header-title font-family-semi-bold' style={{marginTop:'0px',display:'block'}}>{t("Highlights")}</span>

                {
                    arrayCardList.length > 0 &&
                    <span style={{
                        marginLeft: '6px',
                        background: 'var(--project-count-backround-color)',
                        border: '0px solid var(--project-count-border-color)',
                        borderRadius: '20px',
                        padding: '1.2px 10px',
                        fontSize: '13px',
                        color: 'var(--project-count-text-color)'
                    }}>{arrayCardList.length}</span>
                }


                <div style={{flexGrow: '1'}}></div>

                <div className={style.right}>
                    <Dropdown overlayClassName='default-dropdown-style' overlayStyle={{minWidth: '232px'}}
                              menu={{items: sortMenu, onClick: onSortMenuClick}} trigger={['click']}
                              onOpenChange={handleSortOpenChange} open={sortMenuOpen}>
                      <span className='hovered' onClick={(e) => e.preventDefault()}>
                          <div className='flex-row-vertical-center' style={{height:'28px',padding:'0px 8px'}}>
                              <span className='text-color'>{sortTypeDesc}</span>
                              <img className='img-16 ml-6' style={{}} src={getImagePathWithTheme("library_dropdown.svg")}/>
                          </div>
                      </span>
                    </Dropdown>
                </div>
            </>
        }
    }


    /**
     * 渲染列表
     */
    const renderList = ()=>{
        return <div id={'divCardItemContainer'} style={{display: "grid",flexWrap: 'wrap',overflowX:'hidden',overflowY:'auto',
            gridTemplateColumns:gridColumns,
            gap:'12px',
            flexDirection: "row",padding:'0 20px'}}>
            {
                arrayCardList.map((item, i) =>
                    <CardItem key={i} data={item} itemWidth={cardItemSize.width} itemHeight={cardItemSize.width*0.77}
                              isTrash={false} from={FROM_HOME_HIGHLIGHT} subFrom={props.from}
                              isShowChecked={isShowChecked} onCheckedCallback={(item:any)=>{
                        // const nSelectCount = getSelectedArray().length;
                        // let szSelectedTitle = t("Items selected").replace('{0}',nSelectCount+'');
                        // setShowCheckedTitle(szSelectedTitle)
                    }} onActionCallback={async (szAction:string,itemHightlight:any)=>{
                        //将item重新指定为库中的。。。。
                        let item:any = await getCardById(itemHightlight.id);

                        if (szAction == 'delete') {
                            window.showMessageBox(t("Tips"),t("DeleteHighlightConfirm"),t("Cancel"),t("Delete"),null,()=>{
                                if (item){
                                    item.isDeleted = 1;
                                    item.deleteTime = Date.now();
                                    updateCard(item);
                                    //删除这个card所关联的项目
                                    deleteAllCardFromRefProject(item);
                                }

                                const nIndex = arrayCardList.indexOf(itemHightlight);
                                var arrayNewCards = [...arrayCardList];
                                arrayNewCards.splice(nIndex,1);

                                setArrayCardList(arrayNewCards);

                                //更新一份到highlight...
                                updateHighlight({
                                    ...itemHightlight,
                                    isDeleted:1
                                })
                            })
                        }else if (szAction == 'rename'){
                            const itemName = item?.name || itemHightlight.name;
                            window.showCommonInput(itemName,t("Rename")+" ",itemName,t("Cancel"),t("Save"),(szContent:string)=>{
                                window.closeCommonInput();

                                renameCardById(itemHightlight.id,szContent).then(res=>{
                                    updateList();
                                });

                                // item.name = szContent;
                                // updateCard(item).then(res=>{
                                //     //不知道啥排序，直接刷新列表。。
                                //     updateList();
                                // });
                                // //更新一份到highlight...
                                // updateHighlight({
                                //     ...itemHightlight,
                                //     name:szContent
                                // })
                            });
                        }else if (szAction == 'exportPdf' || szAction == 'exportVideo' || szAction == 'exportAudio' || szAction == 'exportFile'){
                            //导出文件
                            const szFilePath = localStorage.getItem(KEY_FILE_DIR) + item.fileName;
                            ipcSend('saveFile', {
                                filters: [{name: "All file", extensions: ['*']}],
                                filePath: szFilePath,
                                fileName: item.name+'.'+getFileNameExt(item.fileName)
                            })
                        }else if (szAction == 'managerTags'){
                            //管理标签
                            window.showManageTags([item]);
                        }else if (szAction == 'addToProject'){
                            //添加到project.
                            dialogChooseProjectRef.current?.onShowDialog([item]);
                        }else if (szAction == 'makeACopy'){
                            const szHtml = await getCardDoc(item.id);
                            const newItem = {
                                ...item,
                                id:generateUUID2(),
                                name:item.name+"("+t("Copy")+")",
                                doc:szHtml
                            }
                            updateCard(newItem).then(res=>{
                                updateList();
                                message.info(t("Copyed"))
                            });
                        }else if (szAction == 'viewAllHighlights'){
                            window.showPdfPreview(item.name,item.id,item.fileName,true,true)
                        }else if (szAction == 'favor'){
                            if (item.isFavirated){
                                item.isFavirated = 0;
                            }else{
                                item.isFavirated = 1;
                            }
                            item.favirateTime = Date.now();
                            updateCard(item,false).then(res=>{
                                postMessage(EVENT_FAVIRIATE_CHANGE);
                                updateList();//刷新列表...
                            });
                        }else if (szAction == 'showInfo'){
                            item.highlight = itemHightlight;
                            if (item.type == 'pdf'){
                                item.highlight = mArrayPdfDatas.current?.find(p=>p.id == item.id);
                            }
                            item.name = itemHightlight.name;
                            window.showInfo('library',item);
                        }else if (szAction == 'copyLink'){
                            if (isYoutubeUrl(itemHightlight.url)){
                                clipboard.write(itemHightlight.url);
                                message.info(t("Link copied to clipboard"));
                            }else{
                                createCopyLink("library", item.id,item.type,null);
                            }
                        }else if (szAction == 'changeSource'){
                            changeSourceEvent(item);
                        }else if (szAction == "importHighlights"){
                            //导入--笔记
                            window.showDialogImportHighlight(async (file,content)=>{
                                onImportHighlights(file,content,itemHightlight);
                            });
                        }else if (szAction == "exportHighlights"){
                            //导出注记
                            saveElementVideoNotesAsJSON(exportCurrentElementVideoNotes(itemHightlight));
                        }else if (szAction == "copyToClipboard"){
                            //导出注记
                            const text = getCurrentElementVideoNotes(itemHightlight);
                            await navigator.clipboard.writeText(text);
                            message.info(t('Notes copied to clipboard'))
                        }
                    }} onMouseUpCallback={(event:any)=>{

                    }}/>
                )
            }
        </div>
    }


    const cellRenderer = ({columnIndex, key, rowIndex, style})=>{
        const item = arrayCardList[rowIndex*mColumnCount.current+columnIndex];
        return <div key={key} style={{...style,}}>
            {
                item?<CardItem key={key} data={item} itemWidth={cardItemSize.width}
                               itemHeight={cardItemSize.height}
                               withPropertyHeight = {getRowHeight(rowIndex)}
                               margin={'8px'}
                               isTrash={false} from={FROM_HOME_HIGHLIGHT} subFrom={props.from} isShowChecked={isShowChecked}
                               onCheckedCallback={(item:any)=>{
                    // const nSelectCount = getSelectedArray().length;
                    // let szSelectedTitle = t("Items selected").replace('{0}',nSelectCount+'');
                    // setShowCheckedTitle(szSelectedTitle)
                }} onActionCallback={async (szAction:string,itemHightlight:any)=>{
                    //将item重新指定为库中的。。。。
                    let item:any = await getCardById(itemHightlight.id);

                    if (szAction == 'delete') {
                        window.showMessageBox(t("Tips"),t("DeleteHighlightConfirm"),t("Cancel"),t("Delete"),null,()=>{
                            if (item){
                                item.isDeleted = 1;
                                item.deleteTime = Date.now();
                                updateCard(item);
                                //删除这个card所关联的项目
                                deleteAllCardFromRefProject(item);
                            }

                            const nIndex = arrayCardList.indexOf(itemHightlight);
                            var arrayNewCards = [...arrayCardList];
                            arrayNewCards.splice(nIndex,1);

                            setArrayCardList(arrayNewCards);

                            //更新一份到highlight...
                            updateHighlight({
                                ...itemHightlight,
                                isDeleted:1
                            })
                        })
                    }else if (szAction == 'rename'){
                        const itemName = item?.name || itemHightlight.name;
                        window.showCommonInput(itemName,t("Rename")+" ",itemName,t("Cancel"),t("Save"),(szContent:string)=>{
                            window.closeCommonInput();

                            renameCardById(itemHightlight.id,szContent).then(res=>{
                                updateList();
                            });
                        });
                    }else if (szAction == 'exportPdf' || szAction == 'exportVideo' || szAction == 'exportAudio' || szAction == 'exportFile'){
                        //导出文件
                        const szFilePath = localStorage.getItem(KEY_FILE_DIR) + item.fileName;
                        ipcSend('saveFile', {
                            filters: [{name: "All file", extensions: ['*']}],
                            filePath: szFilePath,
                            fileName: item.name+'.'+getFileNameExt(item.fileName)
                        })
                    }else if (szAction == 'managerTags'){
                        //管理标签
                        window.showManageTags([item]);
                    }else if (szAction == 'addToProject'){
                        //添加到project.
                        dialogChooseProjectRef.current?.onShowDialog([item]);
                    }else if (szAction == 'makeACopy'){
                        const szHtml = await getCardDoc(item.id);
                        const newItem = {
                            ...item,
                            id:generateUUID2(),
                            name:item.name+"("+t("Copy")+")",
                            doc:szHtml
                        }
                        updateCard(newItem).then(res=>{
                            updateList();
                            message.info(t("Copyed"))
                        });
                    }else if (szAction == 'viewAllHighlights'){
                        window.showPdfPreview(item.name,item.id,item.fileName,true,true)
                    }else if (szAction == 'favor'){
                        if (item.isFavirated){
                            item.isFavirated = 0;
                        }else{
                            item.isFavirated = 1;
                        }
                        item.favirateTime = Date.now();
                        updateCard(item,false).then(res=>{
                            postMessage(EVENT_FAVIRIATE_CHANGE);
                            updateList();//刷新列表...
                        });
                    }else if (szAction == 'showInfo'){
                        item.highlight = itemHightlight;
                        if (item.type == 'pdf'){
                            item.highlight = mArrayPdfDatas.current?.find(p=>p.id == item.id);
                        }
                        item.name = itemHightlight.name;
                        window.showInfo('library',item);
                    }else if (szAction == 'copyLink'){
                        if (isYoutubeUrl(itemHightlight.url)){
                            clipboard.write(itemHightlight.url);
                            message.info(t("Link copied to clipboard"));
                        }else{
                            createCopyLink("library", item.id,item.type,null);
                        }
                    }else if (szAction == 'changeSource'){
                        changeSourceEvent(item);
                    }else if (szAction == "importHighlights"){
                        //导入--笔记
                        window.showDialogImportHighlight(async (file,content)=>{
                            onImportHighlights(file,content,itemHightlight);
                        });
                    }else if (szAction == "exportHighlights"){
                        //导出注记
                        saveElementVideoNotesAsJSON(exportCurrentElementVideoNotes(itemHightlight));
                    }else if (szAction == "copyToClipboard"){
                        //导出注记
                        const text = getCurrentElementVideoNotes(itemHightlight);
                        await navigator.clipboard.writeText(text);
                        message.info(t('Notes copied to clipboard'))
                    }
                }} onMouseUpCallback={(event:any)=>{

                }}/>:<></>
            }

        </div>
    }

    const getRowCount = ()=>{
        let nRowCount = arrayCardList.length / mColumnCount.current;
        nRowCount = Math.ceil(nRowCount);
        return nRowCount;
    }


    const getRowHeight = (rowIndex)=>{
        let nHeight = cardItemSize.height;
        const arrayThisRowData:any = arrayCardList.slice(rowIndex*mColumnCount.current,rowIndex*mColumnCount.current+mColumnCount.current);
        let nTitleHeight = 0;
        for (let i=0;i<arrayThisRowData.length;i++){
            const data = arrayThisRowData[i];
            let nWidth = cardItemSize.width - 38;
            nWidth -= 24;//时间的宽度
            const nH = measureTitleHeight(data.name,nWidth);
            if (nH > nTitleHeight){
                nTitleHeight = nH;
            }
        }
        nHeight += nTitleHeight;

        nHeight += 20;
        return nHeight;
    }

    const renderList1 = ()=>{
        const div = divGridContainerRef.current;//document.getElementById('div-grid-container-'+mThisID.current);
        const nWidth = div?.clientWidth || 0;
        let nHeight = div?.clientHeight;//document.body.clientHeight - 46 - 32 - 20;
        // if (props.from == FROM_LIBRARY){
        //     nHeight -= 12;
        // }
        return arrayCardList.length == 0?<></>:<Grid
            ref={gridRef}
            id={props.from == FROM_HOME_LIBRARY ? 'divCardItemContainer' : 'divCardItemContainer-from-other'}
            style={{padding:'0 12px',position:'relative',outline:'none'}}
            cellRenderer={cellRenderer}
            columnCount={mColumnCount.current}
            rowCount={getRowCount()}
            rowHeight={({index})=>getRowHeight(index) + 16}
            columnWidth={cardItemSize.width + 16}
            height={nHeight}
            width={nWidth - (props.from == FROM_LIBRARY?1:0)}
            onScroll={({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth })=>{
                if (searchKey)return;//带搜索的不分页.
                if (mPageNum.current == -1)return;
                const isBottom = Math.floor(scrollTop + clientHeight) >= Math.floor(scrollHeight);
                // console.log(he);
                if (isBottom && scrollTop > 0) {
                    if (!mIsLoadingMore.current){
                        mIsLoadingMore.current = (true)

                    }
                    console.log('inbottom.....')

                    mPageNum.current++;
                    //不是全部的项目了，不分页....
                    if (!isAllProject()) {
                        mPageNum.current = -1;
                    }

                    console.log('pageNum:'+mPageNum.current);

                    if (mPageNum.current != -1){
                        updateList()?.then(res=>{
                            mIsLoadingMore.current = (false);
                        })
                    }
                }
            }}
        >

        </Grid>
    }

    return (
        <div id={'divPageHighlightContainer'} className={'page-highlight-container'} style={{
            height: 'calc(100% - 0px)',
            paddingBottom: '16px',
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                height: `${HEADER_HEIGHT}px`,
                flexShrink: '0',
                overflowX: 'hidden',
                padding: '0 20px',
                position: 'relative'
            }}>
                {
                    props.from != FROM_LIBRARY &&
                    <>
                        <HomeNavigator margin={'0 0px 0 -4px'}/>
                        {
                            <Input prefix={<IconHomeSearch/>} suffix={<img className='img-mini-small-8 cursor-pointer'
                                                                           style={{display: isStringNullOrEmpty(searchKey) ? "none" : "inherit"}}
                                                                           onClick={() => {
                                                                               setSearchKey('');
                                                                               mSearchKey = '';
                                                                               mPageNum.current = 0;
                                                                               updateList();
                                                                           }}
                                                                           src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>}
                                   variant={"borderless"}
                                   className={'default-font-size input-border'}
                                   style={{width: `${SEARCH_WIDTH}px`, height: '32px',
                                       // backgroundColor: 'var(--input-background-color)',
                                       marginLeft:'15px'}}
                                   placeholder={t("Search highlights")} value={searchKey}
                                   onChange={(event)=>{
                                       mSearchKey = event.currentTarget.value
                                       setSearchKey(mSearchKey);
                                       updateList();
                                   }}/>
                        }
                    </>
                }


                {/*分类类型切换...card - pdf image  video audio*/}
                <div className={'flex-row-vertical-center select-popup-class'} style={{
                    width:props.from == FROM_LIBRARY?'108px':'138px',
                    marginLeft: props.from == FROM_LIBRARY?'0':'20px',
                    borderRadius: '8px',
                    paddingLeft: '12px',
                    position: 'relative',
                    height: '32px',
                    border: '1px solid var(--input-border-color)',
                }}>
                    <img className={'img-18'} src={getImagePathWithTheme('filter_type.svg')}/>
                    <ConfigProvider
                        theme={{
                            components: {
                                Select: {
                                    /* 这里是你的组件 token */
                                    colorBorder: 'transparent',
                                    colorPrimaryHover: 'transparent',
                                    colorPrimary: 'transparent',
                                },
                            },
                        }}>
                        {
                            <Select
                                open={isOpenProjectType}
                                value={t("Type")}
                                style={{width: '100%', position: 'absolute', left: '0', paddingLeft: '0px',marginTop:'0px',}}
                                options={ARRAY_LIBRARY_TYPES}
                                onDropdownVisibleChange={(e) => setIsOpenProjectType(e)}
                                onChange={(value, option) => {

                                }}
                                dropdownRender={(menu) => {
                                    return (
                                        <div style={{overflowX: 'hidden', maxHeight: '320px', overflowY: 'auto'}}>
                                            <>
                                                {
                                                    arrayLibraryTypes.map(p =>
                                                        <>
                                                            {
                                                                p.value == MENU_SEPARATOR &&
                                                                <div key={p.value} className={'line'}
                                                                     style={{margin: '4px 0'}}></div>
                                                            }
                                                            {
                                                                p.value !== MENU_SEPARATOR &&
                                                                <div key={p.value} className={'dropdown-item'}
                                                                     onClick={(event) => {
                                                                         onCheckedItemClicked(p, !p.isChecked)
                                                                     }} onMouseEnter={()=>{
                                                                    const arrayNewType = [...arrayLibraryTypes];
                                                                    arrayNewType.forEach(p=>p.isHoverd = false);
                                                                    p.isHoverd = true;
                                                                    mArraySelectedTypes = arrayNewType;
                                                                    setArrayLibraryTypes(arrayNewType);
                                                                }} onMouseLeave={()=>{
                                                                    const arrayNewType = [...arrayLibraryTypes];
                                                                    arrayNewType.forEach(p=>p.isHoverd = false);
                                                                    mArraySelectedTypes = arrayNewType;
                                                                    setArrayLibraryTypes(arrayNewType);
                                                                }} style={{background: 'transparent',display:'flex',alignItems:'center'}}>
                                                                    <Checkbox style={{marginLeft: '8px'}} checked={p.isChecked}
                                                                              onChange={(e) => {
                                                                                  onCheckedItemClicked(p, e.target.checked)
                                                                              }}></Checkbox>
                                                                    <span className={'span-single-line'} style={{
                                                                        paddingLeft: '12px',
                                                                        paddingRight: '12px',
                                                                        color: 'var(--text-color)'
                                                                    }}>{p.label}</span>
                                                                    {
                                                                        p.isHoverd && p.value != CHECK_ALL &&
                                                                        <Tooltip title={t("ShowOnlyThis")} arrow={false}>
                                                                            <img style={{marginLeft: 'auto'}}
                                                                                 className={'img-16 no-filter mr-6'}
                                                                                 src={getImagePathWithTheme('library_eye_this')} onClick={(e)=>{
                                                                                e.stopPropagation();
                                                                                setIsOpenProjectType(false);
                                                                                //只显示这一种类型..
                                                                                const arrayNewType = [...arrayLibraryTypes];
                                                                                arrayNewType.forEach(item=> {
                                                                                    item.isHoverd = false;
                                                                                    item.isChecked = false;
                                                                                });
                                                                                p.isChecked = true;

                                                                                mArraySelectedTypes = arrayNewType;
                                                                                setArrayLibraryTypes(arrayNewType);
                                                                                localStorage.setItem(KEY_HIGHLIGHT_SELECTED_TYPES,JSON.stringify(arrayNewType));

                                                                                //刷新列表
                                                                                mPageNum.current = 0;
                                                                                updateList()
                                                                            }}/>
                                                                        </Tooltip>
                                                                    }
                                                                </div>
                                                            }
                                                        </>
                                                    )
                                                }
                                            </>
                                        </div>
                                    )
                                }}
                                suffixIcon={<img className='img-16' onClick={() => {
                                    setIsOpenProjectType(true)
                                }}
                                                 src={getImagePathWithTheme('drop_down_select.svg')}/>}
                                dropdownStyle={{width: '228px', overflowY: 'auto'}}>
                            </Select>
                        }
                    </ConfigProvider>
                </div>



                {/*project 按所在项目过滤..all  all in project  not in project*/}
                <div className={'flex-row-vertical-center select-popup-class'} style={{
                    paddingLeft: '12px',
                    borderRadius: '8px',
                    position: 'relative',
                    height: '32px',
                    border: '1px solid var(--input-border-color)',
                    width:props.from == FROM_LIBRARY?'108px':'138px',
                    marginLeft: props.from == FROM_LIBRARY?'12px':'10px'
                }}>
                    {
                        <img className={'img-18'} src={getImagePathWithTheme('filter_project.svg')}/>
                    }

                    <ConfigProvider
                        theme={{
                            components: {
                                Select: {
                                    /* 这里是你的组件 token */
                                    colorBorder: 'transparent',
                                    colorPrimaryHover: 'transparent',
                                    colorPrimary: 'transparent',
                                },
                            },
                        }}>
                        <Select
                            showSearch={true}
                            open={isOpenProjectSelect}
                            onDropdownVisibleChange={(e) => setIsOpenProjectSelect(e)}
                            value={selectProjectValue}
                            style={{
                                width: '100%',
                                position: 'absolute',
                                left: '0',
                                marginTop:'1px',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            options={arrayProjects}
                            onChange={value => {
                                setSelectProjectValue(value);
                            }}
                            onSearch={value => {
                                value = value.toLowerCase();
                                if (isStringNullOrEmpty(value)) {
                                    setArrayProjects(mArrayProjects);
                                } else {
                                    var arrayNewProject = mArrayProjects.filter((p) => {
                                        return p.label?.toLowerCase().indexOf(value) != -1;
                                    });
                                    setArrayProjects(arrayNewProject);
                                }
                            }}
                            dropdownRender={(menu) => {
                                return (
                                    <div style={{overflowX: 'hidden', maxHeight: '320px', overflowY: 'auto'}}>
                                        {
                                            arrayProjects.map(p =>
                                                <>
                                                    {
                                                        p.id == MENU_SEPARATOR &&
                                                        <div key={p.id} className={'line'} style={{margin: '4px 0'}}></div>
                                                    }
                                                    {
                                                        p.id !== MENU_SEPARATOR && p.value != 'all' &&
                                                        <div key={p.value} className={'dropdown-item'} onClick={async () => {
                                                            setIsOpenProjectSelect(false);
                                                            setSelectProjectValue(p.label);
                                                            setIsClearFilterVisible(true)

                                                            mSelectProjectId = p.value;
                                                            //获取这个项目下的所有条目.card
                                                            mPageNum.current = 0;
                                                            //不是全部的项目了，不分页....
                                                            if (!isAllProject()) {
                                                                mPageNum.current = -1;
                                                            }

                                                            //如果选择了当前项目-当前board 要保存一下..
                                                            if (mSelectProjectId == FILTER_PROJECT_CURRENT_PROJECT || mSelectProjectId == FILTER_PROJECT_CURRENT_BOARD) {
                                                                if (window.saveNotes) {
                                                                    await window.saveNotes();
                                                                }
                                                            }

                                                            localStorage.setItem(KEY_FILTER_SELECT_PROJECT_HIGHLIGHT,mSelectProjectId);
                                                            updateList();
                                                        }}>
                                                    <span className={'span-single-line'} style={{
                                                        paddingLeft: '12px',
                                                        paddingRight: '12px'
                                                    }}>{p.label}</span>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        }
                                    </div>
                                )
                            }}
                            suffixIcon={<img className='img-16' onClick={() => setIsOpenProjectSelect(true)}
                                             src={getImagePathWithTheme('drop_down_select.svg')}/>}
                            dropdownStyle={{width: '228px', overflowY: 'auto'}}>
                        </Select>
                    </ConfigProvider>
                </div>


                {/*//标签*/}
                <div className={'flex-row-vertical-center select-popup-class'} style={{
                    paddingLeft: '12px',
                    borderRadius: '8px',
                    position: 'relative',
                    height: '32px',
                    border: '1px solid var(--input-border-color)',
                    width:props.from == FROM_LIBRARY?'108px':'138px',
                    marginLeft:props.from == FROM_LIBRARY?'12px':'10px'
                }}>
                    {
                        <img className={'img-18'} src={getImagePathWithTheme('filter_tag.svg')}/>
                    }

                    <ConfigProvider
                        theme={{
                            components: {
                                Select: {
                                    /* 这里是你的组件 token */
                                    colorBorder: 'transparent',
                                    colorPrimaryHover: 'transparent',
                                    colorPrimary: 'transparent',
                                },
                            },
                        }}>
                        <Select
                            showSearch={true}
                            open={isOpenTagSelect}
                            onDropdownVisibleChange={(e)=>setIsOpenTagSelect(e)}
                            value={selectTagValue}
                            style={{
                                width: '100%',
                                position: 'absolute',
                                left: '0',
                                display: 'flex',
                                alignItems: 'center',
                                marginTop:'1px',
                            }}
                            options={arrayTags}
                            onSearch={value => {
                                if (isStringNullOrEmpty(value)) {
                                    setArrayTags(mArrayTags);
                                }else {
                                    var arrayNewTag = mArrayTags.filter((p)=>{
                                        return p.label?.indexOf(value) != -1;
                                    });
                                    setArrayTags(arrayNewTag);
                                }
                            }}
                            dropdownRender={(menu)=>{
                                return(
                                    <>
                                        {
                                            // props.from == FROM_LIBRARY && arrayTags.length == 0 &&
                                            // <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                        }
                                        <div style={{overflowX: 'hidden', maxHeight: '320px',overflowY: 'auto',display:'flex',flexDirection:'column'}}>
                                            {
                                                arrayTags.map(p =>
                                                    <>
                                                        {
                                                            p.id == MENU_SEPARATOR &&
                                                            <div key={p.value} className={'line'}
                                                                 style={{margin: '4px 0'}}></div>
                                                        }
                                                        {
                                                            p.id !== MENU_SEPARATOR &&
                                                            <div key={p.value} className={'dropdown-item'} onClick={() => {
                                                                setIsOpenTagSelect(false);
                                                                setSelectTagValue(p.label);
                                                                mSelectTag = p.label;
                                                                mPageNum.current = -1;
                                                                //更新列表...
                                                                updateList();

                                                                localStorage.setItem(KEY_FILTER_SELECT_TAG_HIGHLIGHT,p.label );
                                                                setIsClearFilterVisible(p.value != t('Tags') || !isAllProject())
                                                            }}>
                                                    <span className={'span-single-line'} style={{
                                                        paddingLeft: '12px',
                                                        paddingRight: '12px'
                                                    }}>#{p.label}</span>
                                                            </div>
                                                        }
                                                    </>
                                                )
                                            }
                                            {
                                                arrayTags.length == 0 &&
                                                <span style={{margin:'6px 12px 0px 12px'}}>{t("No tags yet")}</span>
                                            }

                                            <div style={{flexGrow:'1'}}></div>

                                            {
                                                props.from != FROM_LIBRARY &&
                                                <>
                                                    <div className={'line'} style={{margin: '6px -6px',background:'var(--vertical-line-color)',flexShrink:'0'}}></div>
                                                    {/*添加manager*/}
                                                    <div className={'flex-row-vertical-center cursor-pointer'} style={{padding: '6px 12px'}}
                                                         onClick={() => {
                                                             // dialogAllTagManagerRef.current?.onShowDialog();
                                                             postMessage(EVENT_SWITCH_HOME_LIST_MENU,{name:'tags'});
                                                         }}>
                                                        <img className={'img-16'} src={getImagePathWithTheme('go_to_tags')}/>
                                                        <span className={'ml-8'} style={{marginTop:'1px'}}>{t("Go to tags")}</span>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </>
                                )
                            }}
                            suffixIcon={<img className='img-16' onClick={()=>setIsOpenTagSelect(true)} src={getImagePathWithTheme('drop_down_select.svg')}/>}
                            dropdownStyle={{width: '228px', overflowY: 'auto'}}>
                        </Select>
                    </ConfigProvider>
                </div>

                {/*清空 过滤条件*/}
                {
                    isClearFilterVisible &&
                    <img style={{marginLeft: '22px'}} className={'img-16 cursor-pointer mt-2'}
                         src={getImagePathWithTheme('reset_search')}
                         onClick={() => {
                             mSelectTag = '';
                             mSelectProjectId = 'all';
                             setSelectProjectValue('all');
                             setSelectTagValue(t('Tags'));
                             setIsClearFilterVisible(false);

                             localStorage.setItem(KEY_FILTER_SELECT_PROJECT_HIGHLIGHT,'all');
                             localStorage.setItem(KEY_FILTER_SELECT_TAG_HIGHLIGHT,t(''))

                             mPageNum.current = 0;
                             updateList()
                         }}/>
                }


                {/*选择---new card/pdf/video/audio/image*/}
                {
                    // !isShowChecked &&
                    // <>
                    //     <div style={{padding: '0 0px', marginLeft: '22px'}}
                    //          className={'flex-center cursor-pointer default-font-size hovered-text-main-blue-color'}
                    //          onClick={() => {
                    //              setIsShowChecked(!isShowChecked);
                    //              let szSelectedTitle = t("Items selected").replace('{0}', '0');
                    //              setShowCheckedTitle(szSelectedTitle)
                    //          }}>{t("Select")}</div>
                    //     <div style={{flexGrow: '1'}}></div>
                    // </>
                }


                {
                    isShowSearch &&
                    <Input prefix={<IconHomeSearch/>} id={'input-library-search-1'}
                           suffix={<img className='img-mini-small-8 cursor-pointer'
                                        style={{display: "inherit"}}
                                        onClick={() => {
                                            mSearchKey = '';
                                            setSearchKey('');
                                            setIsShowSearch(false);
                                            updateList();
                                        }}
                                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>}
                           variant={"borderless"}
                           className={'input-border'}
                           style={{
                               position: 'absolute',
                               width: 'calc(100% - 42px)',
                               height: '32px',
                               // backgroundColor: 'var(--input-background-color)',
                           }}
                           placeholder={t("Search library")} value={searchKey} onChange={(event) => {
                        mSearchKey = event.currentTarget.value;
                        setSearchKey(mSearchKey);
                        updateList();
                    }}
                    />
                }

                {
                    props.from == FROM_LIBRARY &&
                    <>
                        <div style={{flexGrow: '1'}}></div>
                        <Dropdown overlayClassName='default-dropdown-style' overlayStyle={{minWidth: '232px'}}
                                  menu={{items: sortMenu, onClick: onSortMenuClick}} trigger={['click']}
                                  onOpenChange={handleSortOpenChange} open={sortMenuOpen}>
                            <div className={'flex-center ml-12'} style={{
                                width: '16px',
                                height: '32px',
                                borderRadius: '8px',
                                flexShrink:'0',
                                border: '0px solid var(--border-color)',
                            }}>
                                <img className={'img-16  cursor-pointer'}
                                     src={getImagePathWithTheme('library_filter.svg')}
                                     onClick={(e) => e.preventDefault()}/>
                            </div>
                            {/*<img className={'img-16 cursor-pointer'} onClick={(e) => e.preventDefault()}*/}
                            {/*     src={getImagePathWithTheme('icon_sort')}/>*/}
                        </Dropdown>

                    </>
                }

            </div>


            {/*标题*/}
            {
                props.from != FROM_LIBRARY &&
                <div className={'page-highlight-title'}
                     style={{marginTop: `${PAGE_TITLE_MARGIN_TOP}px`, padding: '0 20px'}}>
                    {
                        renderTitleRow()
                    }
                </div>
            }


            {/*grid列表*/}
            <div ref={divGridContainerRef} style={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: '1',
                overflowY: 'auto',
                overflowX: 'hidden',
                padding: '0 0px',
            }} >
                {
                    renderList1()
                }
            </div>



            {
                isEmptyData && isStringNullOrEmpty(searchKey) &&
                <span style={{
                    position: 'absolute', left: '50%', top: '50%',
                    transform: 'translate(-50%,-50%)', color: 'var(--text-color-66666)',
                    whiteSpace: 'pre-wrap',
                    lineHeight: '22px',
                    textAlign: 'center'
                }}>{t("LibraryIsEmptyTips")}</span>
            }

            {/*搜索结果*/}
            {
                arrayCardList.length == 0 && !isStringNullOrEmpty(searchKey) &&
                <div style={{
                    position: 'absolute',
                    left: '50%',
                    top: '10%',
                    transform: 'translateX(-50%)',
                    display: isStringNullOrEmpty(searchKey) ? 'none' : 'inline'
                }}>
                    <div className={'flex-column-center'}
                         style={{
                             display: arrayCardList.length === 0 ? 'flex' : 'none',
                             zIndex: '100',
                             marginTop: '36px'
                         }}>
                        <img style={{height: '294px', width: '294px'}}
                             src={getImagePathWithTheme("search_no_result")}></img>
                        <span className='description-color ml-8' style={{
                            textAlign: 'center',
                            lineHeight: '22px'
                        }}>{t("No results found").replace('%s', searchKey)}</span>
                    </div>
                </div>
            }

            {
                isLoading &&
                <div style={{
                    position: 'absolute',
                    zIndex: '2004',
                    left: LEFT_MENU_WIDTH + 'px',
                    top: '0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'calc(100% - ' + LEFT_MENU_WIDTH * 2 + 'px)',
                    height: '100%'
                }}>
                    <Spin indicator={IconIndicatorBlue} spinning={isLoading}>

                    </Spin>
                </div>

            }

            {
                tipsInfo &&
                <div className={'flex-center'} style={{
                    position: 'absolute',
                    zIndex: '1001',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    top: '80px',
                    height:'36px',
                    borderRadius:'8px',
                    padding:'0 26px',
                    minWidth:'180px',
                    background:'var(--dialog-dialog-background-color-2c)',
                    boxShadow:'var(--dialog-box-shadow)'
                }}>
                    <span>{tipsInfo}</span>
                    <span style={{textDecoration:'none',marginLeft:'22px'}} className={'link-color cursor-pointer'} onClick={()=>{
                        //打开这个project....
                        if (mProjectInfo) {
                            window.navigateOrigin(getDrawPath(),{state:{noteData:mProjectInfo,searchKey:''}})
                        }
                    }}>{t("View")}</span>
                </div>
            }


            <DialogChooseProject ref={dialogChooseProjectRef} onOkEvent={async (project:any,arraySelectItems:any)=>{
                let doc;
                const isNew = project.isCreateNew;

                if (isNew) {
                    if (await hasBeyondFreeLimit()){
                        postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''})
                        return;
                    }
                    //添加一个空白的project...
                    project = createEmptyProject(project.id,project.name);
                    doc = {doc:project.doc};
                }else {
                    doc = await getNoteDoc(project.id);
                }
                let jsonDoc = doc.doc;
                if (isString(doc.doc)) {
                    jsonDoc = JSON.parse(doc.doc);
                }

                {
                    //以文件的方式插入....
                    let ptX = (document.body.clientHeight)*0.5;
                    let ptY = 210;

                    for (let i=0;i<arraySelectItems.length;i++) {
                        const item = arraySelectItems[i];

                        let w = 280,h = 210;
                        if (isVideo(item.fileName)){
                            const wh = await getVideoScale("localfile://"+item.fileName);
                            w = 400;
                            h = w*wh.videoHeight/wh.videoWidth;
                        }else if (isPdf(item.fileName)){
                            const imgSize = await getBase64ImageSize(item.thumbImage);
                            // console.log('get pdf thumb.....end...')
                            w = 200;
                            h = w*imgSize?.height/imgSize?.width;
                            if (!h){
                                h = w*1.4;
                            }
                        }

                        ptX += w;

                        if (isSupportVideoAnnoUrl(item.fileName)) {
                            if (!jsonDoc.canvas[0].drawJson.elements.some(p=>p.id == item.id)) {
                                var element = {
                                    type: "embeddable",
                                    version: 1,
                                    isDeleted: false,
                                    id: item.id,
                                    strokeWidth: 1,
                                    strokeStyle: "solid",
                                    roughness:0,
                                    roundness: {
                                        type:ROUNDNESS.ADAPTIVE_RADIUS,
                                        value:12
                                    },
                                    link:item.fileName,
                                    opacity: 100,
                                    angle: 0,
                                    x: ptX - 130,
                                    y: ptY - h / 2,
                                    strokeColor: "#F0EFF5",
                                    backgroundColor: "white",
                                    fillStyle:'solid',
                                    width: 380,
                                    height: 260,
                                    locked:false,
                                    groupIds: []
                                }
                                //添加到第一个board
                                jsonDoc.canvas[0].drawJson.elements.push(element);
                            }else {
                                message.info(t("CardIsAlreadOn").replace("{0}",t("Video")));
                            }
                        }else {
                            let element = {
                                type: "iframe",
                                version: 1,
                                isDeleted: false,
                                id: generateUUID2(),//这里使用新的ID，原始ID保存到customData里面
                                strokeWidth: 0.0000001,
                                strokeStyle: "solid",
                                roughness: 0,
                                roundness: {
                                    type: ROUNDNESS.ADAPTIVE_RADIUS,
                                    value: 16
                                },
                                opacity: 100,
                                angle: 0,
                                locked: false,
                                x: ptX - 130,
                                y: ptY - h / 2,
                                strokeColor: "white",
                                backgroundColor: "white",
                                fillStyle: 'solid',
                                width: w,
                                height: h,
                                groupIds: [],
                                isLockRatio: true,
                                isHidden: false,
                                customData: {
                                    generationData: {
                                        status: 'done',
                                        id: item.id,
                                        html: '',
                                        type: 'file',
                                        fileName: item.fileName,
                                        name: item.name,
                                        showName: item.name
                                    }
                                }
                            }
                            //添加到第一个board
                            jsonDoc.canvas[0].drawJson.elements.push(element);
                        }
                    }
                }

                if (isNew) {
                    project.doc = JSON.stringify(jsonDoc);
                    updateNote(project).then(res=>{
                        mProjectInfo = project;
                        setTipsInfo(t("Added to project").replace("{0}",arraySelectItems.length));
                        setTimeout(()=>{
                            setTipsInfo('');
                        },3000);
                    });
                }else {
                    //update doc
                    doc.doc = JSON.stringify(jsonDoc);
                    mProjectInfo = project;
                    updateNoteDoc(doc).then(res=>{
                        setTipsInfo(t("Added to project").replace("{0}",arraySelectItems.length));
                        setTimeout(()=>{
                            setTipsInfo('');
                        },3000);
                    });
                }
            }}/>

        </div>
    )
})

export default PageHighlight;